<template>
  <Sheet v-loading="loading.actions['systemNews']">
    <h2>{{routeTitle}}</h2> 
    <div class="dataTables_scroll">
        <!-- <div class="dataTables_scrollHead" style="overflow: hidden; position: relative; border: 0px; width: 100%;">
            <table style="margin:0.5em; width:100%;" cellspacing="0" >
                <thead>
                    <tr>
                        <th style="text-align: left; text-shadow: rgba(0, 0, 0, 0.2) 2px 6px 5px, rgba(255, 255, 255, 0.4) 0px -4px 30px;">{{$t('Anno_txt')}}</th>
                    </tr>
                </thead>
            </table>
        </div> -->
        <div class="dataTables_scrollBody" style="position: relative; overflow: auto; max-height: 400px; width: 100%; border-bottom: 1px solid #111; border-top: 1px solid #111;">
            <table id="example" class="compact cell-border row-border dataTable no-footer" style="border-bottom:none; width: 100%;">
                <tbody>
                    <tr v-for="(item,index) in newsList" :key="index" :index="'0'+index" :name="'N1'+index"
                          v-show="null != newsList">
                        <td style="width:9em; padding:0.25em 0.75em; text-align:left; vertical-align: top;">
                          <i class="el-icon-time"></i>{{item.startDate | dateFormat}}<img src='@/assets/images/gif-new.gif' v-show="checkNewsTime(item.startDate)">
                        </td>
                        <td style="padding:0.25em 0.5em; text-align:left; vertical-align: top; display: inherit;">
                          <span v-html="item.content" v-if="2==item.newsType"></span>
                          <span v-else>{{item.content}}</span>
                          <span style="padding: 0 0 0 1em;"
                            v-for="(f,index) in item.info"
                            :key="index" 
                            :index="'0'+index" 
                            :name="'F1'+index">
                            <a target="_blank"
                              :title="f.name"
                              :href="base.concat('api/News/getAttach/').concat(f.rowId)">
                              <img v-if="f.img != null" :src="f.img" style="height:1.5em;" alt=""/>
                              <span v-else>
                                <img v-if="checkFileType(f.type) === 1" src="@/assets/images/word.gif" style="height:1.25em;" />
                                <img v-else-if="checkFileType(f.type) === 2" src="@/assets/images/image.gif" style="height:1.25em;"/>
                                <img v-else-if="checkFileType(f.type) === 3" src="@/assets/images/pdf.gif" style="height:1.25em;" />
                                <img v-else src="@/assets/images/attachment.png" style="height:1.25em;" />
                              </span>
                            </a>
                          </span>
                        </td>
                    </tr>
                    <tr v-show="0 == data1Len">
                        <td colspan="2" style="line-height:2.25em; text-align:left;">目前無最新消息~</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </Sheet>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import routeTitleMixin from './routeTitleMixin';
import {base} from '../constants';

export default {
  name: 'billboard',
  mixins: [routeTitleMixin],
  data () {
    return {
      data1Len: 0,
      base: base,
    }
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('auth', ['name', 'userId', 'roleId']),
    ...mapState('systemNews',['newsList']),
  },
  filters: {  
    dateFormat:function(input) {   
       var d = new Date(input);
       var year = d.getFullYear();
       var month = d.getMonth() + 1;
       var day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate(); 
       return  year+ '/' + month + '/' + day ; 
    }  
  },
  methods: {
    ...mapActions('systemNews', {
      getSystemNews: 'getSystemNews',
      clearList: 'clearNewsList',
    }),
    checkNewsTime: function (startTime) {
      var date1 = new Date(startTime);
      var date2 = new Date();
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

      return (isNaN(diffDays) || (diffDays > 7) ? false : true);
    },
    checkFileType: function(mimeType) {
      var ret = 0;
      if (mimeType === 'application/msword' || mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        ret = 1;
      } else if (mimeType === 'image/jpeg') {
        ret = 2;
      } else if (mimeType === 'application/pdf') {
        ret = 3;
      }
      return ret;
    },
    async query () {      
      var curDate = new Date()
      var tObj = {
        id: 1,
        startDate:[curDate.getFullYear(), curDate.getMonth() + 1, curDate.getDate()].join('-'),
        val: [this.roleId]
      };
      
      await this.clearList();
      const {success} = await this.getSystemNews(tObj);
      if (success) {
        this.data1Len = this.newsList.length;
      }
    }
  },
  
  watch: {
    async roleId(to) {
      await this.query();
    },
  },

  async created () {
    console.log('=== created Billboard ===');
    if ('' != this.roleId) {
      await this.query();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
